import {i18n} from '@/setup/i18n-setup';

export async function confirmDelete(vs, acceptFunc, payload, message) {

  vs.dialog({
    type: 'confirm',
    color: 'danger',
    title: i18n.t('general.confirmDelete'),
    text: message ? message : i18n.t('general.confirmDeleteMessage'),
    acceptText: i18n.t('general.delete'),
    cancelText: i18n.t('general.cancel'),
    accept: async () => {
      await acceptFunc(payload);
    }
  });

}

export async function confirmSave(vs, acceptFunc, payload) {

  vs.dialog({
    type: 'confirm',
    color: 'primary',
    title: i18n.t('general.confirm-save'),
    text: i18n.t('general.confirm-save-message'),
    acceptText: i18n.t('general.save'),
    cancelText: i18n.t('general.cancel'),
    accept: async () => {
      if(payload){
        await acceptFunc(payload);
      }else{
        await acceptFunc();
      }
    }
  });

}

export async function confirmUpload(vs, acceptFunc, payload) {

  vs.dialog({
    type: 'confirm',
    color: 'primary',
    title: i18n.t('general.confirm-upload'),
    text: i18n.t('general.confirm-upload-message'),
    acceptText: i18n.t('general.upload'),
    cancelText: i18n.t('general.cancel'),
    accept: async () => {
      if(payload){
        await acceptFunc(payload);
      }else{
        await acceptFunc();
      }
    }
  });

}

export async function confirmGeneral(vs
                              , acceptFunc
                              , payload
                              , title = i18n.t('general.confirm-save')
                              , text = i18n.t('general.confirm-save-message')
                              , acceptText = i18n.t('general.save')
                              , cancelText = i18n.t('general.cancel')) {

  vs.dialog({
    type: 'confirm',
    color: 'primary',
    title: title,
    text: text,
    acceptText: acceptText,
    cancelText: cancelText,
    accept: async () => {
      if(payload){
        await acceptFunc(payload);
      }else{
        await acceptFunc();
      }
    }
  });

}

export async function warningDialog(vs, text) {
  vs.dialog({
    color: 'warning',
    title: i18n.t('general.warning'),
    text: text,
    acceptText: i18n.t('general.close'),
    cancelText: i18n.t('general.close'),
  });
}

export async function successDialog(vs, text) {
  vs.dialog({
    color: 'success',
    title: i18n.t('general.success'),
    text: text,
    acceptText: i18n.t('general.close'),
    cancelText: i18n.t('general.close'),
  });
}

export async function errorDialog(vs, text) {
  vs.dialog({
    color: 'danger',
    title: i18n.t('general.error'),
    text: text,
    acceptText: i18n.t('general.close'),
    cancelText: i18n.t('general.close'),
  });
}
